import { Card, CardBody, CardTitle, Table } from "reactstrap";
import propTypes from 'prop-types';

const AccountingDetailsTable = ({title, columns, tableData}) => {
  return (
    <div>
      <Card style={{ boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.05)', marginBottom: '30px' }}>
        <CardBody>
          <CardTitle tag="h5">{title}</CardTitle>
          <Table className="no-wrap mt-3 align-middle" responsive borderless size="sm">
            <thead>
              <tr>
                <th>Concepto</th>
                <th>Fecha</th>
                <th>Tipo</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              { tableData.length === 0 ? (
                  <div className="text-center text-gray-500">No hay datos disponibles.</div>
                ) : (
              tableData.map((tdata, index) => (
                <tr key={`${tdata.id}-${index}`} className="border-top">
                  <td>
                    <div className="d-flex align-items-center p-0">
                      <div className="ms-3">                        
                        <h6 className="mb-0" style={{fontWeight: "bold"}}>{tdata.category}</h6>
                        <span className="text-muted">{tdata.description}</span>
                      </div>
                    </div>
                  </td>
                  <td>{tdata.date}</td>
                  <td>{tdata.paymentType}</td>
                  <td>{tdata.total}</td>
                </tr>
              )))}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </div>
  );
};

AccountingDetailsTable.propTypes = {
  title: propTypes.string.isRequired,
  columns: propTypes.array,
  tableData: propTypes.array.isRequired
};

export default AccountingDetailsTable;
